var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"text-sm md:text-base flex items-baseline",attrs:{"for":_vm.idFor}},[_vm._t("default"),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }